import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type CodingFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const CodingFilled = forwardRef<SVGSVGElement, CodingFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.25 -5.25) scale(0.71875)">
        <path d="M37.4705 8H10.5752C9.89224 8 9.23722 8.27132 8.75427 8.75427C8.27132 9.23722 8 9.89224 8 10.5752V37.4705C8.01198 38.1455 8.28859 38.7889 8.77024 39.262C9.2519 39.7351 9.90009 40.0001 10.5752 40H37.4705C38.1377 39.9883 38.7743 39.718 39.2461 39.2461C39.718 38.7743 39.9883 38.1377 40 37.4705V10.5752C40.0001 9.90009 39.7351 9.2519 39.262 8.77024C38.7889 8.28859 38.1455 8.01198 37.4705 8V8ZM13.8971 25.3257C13.6413 25.3294 13.3902 25.2564 13.1763 25.116C12.9624 24.9756 12.7954 24.7743 12.697 24.5382C12.5986 24.302 12.5732 24.0417 12.6242 23.7909C12.6751 23.5402 12.8001 23.3105 12.9829 23.1314L17.1429 19.0019L12.9829 14.8419C12.8638 14.7218 12.7695 14.5795 12.7055 14.423C12.6414 14.2665 12.6088 14.0989 12.6095 13.9299C12.6102 13.7608 12.6442 13.5935 12.7096 13.4375C12.775 13.2816 12.8704 13.14 12.9905 13.021C13.233 12.7805 13.561 12.6462 13.9025 12.6476C14.0716 12.6483 14.2389 12.6823 14.3949 12.7477C14.5508 12.8131 14.6924 12.9085 14.8114 13.0286L19.8248 18.1029C19.9441 18.2218 20.0388 18.3631 20.1034 18.5187C20.168 18.6742 20.2012 18.8411 20.2012 19.0095C20.2012 19.178 20.168 19.3448 20.1034 19.5004C20.0388 19.656 19.9441 19.7973 19.8248 19.9162L14.8114 24.9448C14.692 25.0658 14.5496 25.1618 14.3926 25.2273C14.2356 25.2927 14.0672 25.3261 13.8971 25.3257ZM27.779 25.3257H20.6781C20.3366 25.3257 20.0091 25.1901 19.7676 24.9486C19.5261 24.7071 19.3905 24.3796 19.3905 24.0381C19.3905 23.6966 19.5261 23.3691 19.7676 23.1276C20.0091 22.8861 20.3366 22.7505 20.6781 22.7505H27.8095C28.151 22.7505 28.4785 22.8861 28.72 23.1276C28.9615 23.3691 29.0971 23.6966 29.0971 24.0381C29.0971 24.3796 28.9615 24.7071 28.72 24.9486C28.4785 25.1901 28.151 25.3257 27.8095 25.3257H27.779Z" />
      </g>
    </svg>
  ),
);

CodingFilled.displayName = 'CodingFilled';

export default CodingFilled;
